import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const CustomScrollLink = ({ to, spy, smooth, offset, duration, onClick, children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = () => {
        if (to.startsWith("/")) {
            // Navigate to a different route
            navigate(to);
        } else if (location.pathname === "/") {
            // Scroll to section if on the home route
            onClick && onClick();
        } else {
            // Redirect to home with hash
            navigate(`/#${to}`);
        }
    };

    useEffect(() => {
        // Handle smooth scrolling after redirect if hash matches the section
        if (location.hash === `#${to}` && location.pathname === "/") {
            const element = document.getElementById(to);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location, to]);

    return (
        <ScrollLink
            to={to}
            spy={spy}
            smooth={smooth}
            offset={offset}
            duration={duration}
            onClick={handleClick}
        >
            {children}
        </ScrollLink>
    );
};

export default CustomScrollLink;
